import i18next from "i18next";
import React from "react";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { Link, useNavigate } from "react-router-dom";

export default function KYCStep1() {
  const navigate = useNavigate();

  return (
    <div className="container">
      <div className=" w-full px-4 py-4  bg-[#100F14] flex justify-between items-center gap-2">
        <span className="text-[#fff]">{i18next.t("kyc_title")}</span>
        <div className="cursor-pointer" onClick={() => navigate("/member/kyc")}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
              fill="#fff"
            />
          </svg>
        </div>
      </div>
      <div className="flex flex-col  px-4 my-4">
        <div className="py-[6px] px-4 flex items-center bg-[#fff4e5] rounded mb-4">
          <div className="py-2 text-[#663c00] ">{i18next.t("note17")}</div>
        </div>
        <div>
          <div className="text-[#fff]">{i18next.t("note18")}</div>
          <div className="pl-[40px] my-4">
            <li className="text-[#888888]">
              <span>{i18next.t("note19")}</span>
            </li>
            <li className="text-[#888888]">
              <span>{i18next.t("note20")}</span>
            </li>
          </div>
          <img
            className="w-full"
            src="https://api.demo92.apptestlive.com/assets/images/id.png"
            alt=""
          />
        </div>
        <div>
          <div className="text-[#fff]">{i18next.t("help")}</div>
          <div className="pl-[40px] my-4">
            <li className="text-[#888888]">
              <span>{i18next.t("note21")}</span>
            </li>
            <li className="text-[#888888]">
              <span>{i18next.t("note22")}</span>
            </li>
          </div>
          <img
            className="w-full"
            src="https://api.demo92.apptestlive.com/assets/images/selfie.webp"
            alt=""
          />
        </div>
        <div className="w-full mt-6">
          <button
            className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-sizeMedium MuiButton-containedSizeMedium p-0 w-full overflow-hidden normal-case css-156xhyz"
            type="button"
          >
            <Link
              className=" flex justify-center w-full px-6 py-3  bg-[#3d5afe]  text-white text-md text-center text-medium rounded"
              to="/member/kyc/step2"
            >
              {i18next.t("next_step")}
            </Link>
            <span className="MuiTouchRipple-root css-w0pj6f" />
          </button>
        </div>
      </div>
    </div>
  );
}
